<template>
    <v-container id="DetalleReporte" style="padding-top: 80px !important" class="pt-5">
        <div v-if="showcargando == true"
             id="cargando"
             style="z-index: 600;"
             wire:loading
             class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center">
            <div class="loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4"></div>
            <h2 class="text-center text-white text-xl font-semibold">Cargando...</h2>
            <p class="w-1/3 text-center text-white">
                Esto puede tardar unos segundos, no cierre esta página.
            </p>
        </div>


        <v-row class="ma-1 ">
            <v-card width="100%" class="mx-2">
                <Menu></Menu>
            </v-card>

        </v-row>


        <v-row class="ma-1 ">
            <v-card v-if="showcargando == false" class="px-2 py-1 mr-2" elevation="23" style="margin-top: 15px !important;" color="green">
                <span style='color: white; margin: 15px;'>REPORTE: {{this.datos.nrreporte}} - {{this.datos.svindice}}</span>
            </v-card>

            <v-card v-if="showcargando == false" class="px-2 py-1" elevation="23" style="margin-top:15px !important; " color="#4EB8B8">
                <span style='color: white; margin: 15px;'>TERCERO: {{this.datos.d3nombre.toUpperCase()}}</span>
            </v-card>

        </v-row>
        <v-row class="ma-1 ">
            <v-card class="px-2 py-1 mr-2" elevation="23" style="margin-top: 15px !important;" color="#42A5F5">
                <span style='color: white; margin: 15px;'>MONTO: {{nrmontoneg}}</span>
            </v-card>

        </v-row>


        <v-card v-if="showcargando == false" elevation="6" class="base-card-container pa-0 mt-4">
            <v-card-title class="pa-5 pb-3 primary">
                <v-icon class="pr-4" :color="'#FFFFFF'">mdi-square-inc-cash</v-icon>
                <p v-if="this.datos.nrtippago == 1" style="color: white;">Pago Único</p>

                <p v-if="this.datos.nrtippago == 2" style="color: white;">Pagos Diferidos</p>



            </v-card-title>
            <v-form>
                <v-card-text v-if="showcargando == false">

                    <v-btn @click="$router.push({ name: 'SeguimientoRecuperaciones' }).catch((error) => error);" v-if="validacionEstadistico == 0" class="ma-2" color="green">
                        <span style='color: white;'>Regresar</span>
                    </v-btn>

                    <v-btn @click="$router.push({ name: 'EstadisticoRecuperaciones' }).catch((error) => error);" v-if="validacionEstadistico == 1" class="ma-2" color="green">
                        <span style='color: white;'>Regresar</span>
                    </v-btn>


                    <v-btn v-if="validacionEstadistico == 0 || datosDocs.nrfoliodanios != null ||  datosDocs.nrfoliolesiones != null" @click="agregarDocumentos()" class="ma-2" color="green">
                        <span style='color: white;'>Agregar Documento</span>
                    </v-btn>

                    <v-row v-if="showTable" justify="center">
                        <v-col cols="12">
                            <DataTable :url="urlPago"
                                       class="tablaPagos"
                                       :columns="columnsPago"
                                       :params="displayInputsPago"
                                       :order="[]"
                                       select="single"
                                       @input="mostrarMov"
                                       :formatterActions="formatterActions"
                                       @apiDT="apiDT = $event"></DataTable>



                        </v-col>
                    </v-row>



                </v-card-text>
            </v-form>
        </v-card>

        <v-card v-if="agregarDocs == true" elevation="6" class="base-card-container pa-0 mt-4">
            <v-card-title class="pa-5 pb-3 primary">
                <v-icon class="pr-4" :color="'#FFFFFF'">mdi-square-inc-cash</v-icon>
                <p style="color: white;">Alta Documentos</p>

            </v-card-title>
            <v-form>
                <v-card-text>

                    <v-row justify="center">
                        <v-col cols="6">

                            <div style="margin-left: 20px; margin-right:20px; margin-top:20px">

                                <v-row>
                                    <span class="font-weight-bold type-label-style">Daños</span>
                                </v-row>

                                <v-row style="margin-top:15px;">
                                    <span class="type-label-style">Tipo de Documento:</span>


                                </v-row>

                                <v-row style="margin-top:15px;">


                                    <v-select return-object
                                              solo
                                              :items="docsDanos"
                                              v-model="danoSelected"
                                              item-text="dodescrip"
                                              item-value="doclave"
                                              placeholder="Seleccione Documento"
                                              :disabled="documentosBlock"
                                              :filled="documentosBlock">

                                    </v-select>
                                </v-row>


                                <v-row style="margin-top:15px;">
                                    <span class="type-label-style">Monto de documento:</span>


                                </v-row>

                                <v-row style="margin-top:15px;">
                                    <v-text-field class="align-left-button"
                                                  v-model="danosDatos.montoDanos"
                                                  v-on:blur="datos.nombre = datos.nombre != null ? datos.nombre.trim() : null"
                                                  outlined
                                                  @keypress="filter()"
                                                  maxlength="8"
                                                  dense
                                                  :disabled="danosBlocked"
                                                  :filled="danosBlocked"
                                                  :error-messages="validation.errorMontoDanos">
                                    </v-text-field>


                                </v-row>


                                <v-row style="margin-top:15px;">
                                    <span class="type-label-style">Folio:</span>


                                </v-row>

                                <v-row style="margin-top:15px;">
                                    <v-text-field class="align-left-button"
                                                  v-model="danosDatos.folioDanos"
                                                  v-on:blur="danosDatos.folioDanos = danosDatos.folioDanos != null ? danosDatos.folioDanos.trim() : null"
                                                  outlined
                                                  maxlength="50"
                                                  dense
                                                  :disabled="danosBlocked"
                                                  :filled="danosBlocked"
                                                  :error-messages="validation.folioDanos">
                                    </v-text-field>


                                </v-row>

                                <v-row style="margin-top:15px;">
                                    <span class="type-label-style">Aseguradora:</span>


                                </v-row>

                                <v-row style="margin-top:15px;">


                                    <v-select return-object
                                              solo
                                              :items="aseguradoras"
                                              v-model="asegSelected"
                                              item-text="asenombre"
                                              item-value="aseclave"
                                              placeholder="Seleccione Aseguradora"
                                              :disabled="asegBlock"
                                              :filled="asegBlock"
                                              ref="asegSelected">
                                    </v-select>
                                </v-row>

                                <v-row v-if="!documentosBlock" style="margin-top:15px;">
                                    <span class="type-label-style">Observaciones:</span>



                                </v-row>

                                <v-row v-if="!documentosBlock" style="margin-top:15px;">
                                    <v-textarea id="textareaobs"
                                                v-on:blur="danosDatos.obsDanos = danosDatos.obsDanos != null ? danosDatos.obsDanos.trim() : null"
                                                v-model="danosDatos.obsDanos"
                                                class="mt-2 textarea"
                                                outlined
                                                :rules="rulestextarea"
                                                :disabled="documentosBlock"
                                                :filled="documentosBlock"
                                                :error-messages="validation.errorObsDocs">

                                    </v-textarea>


                                </v-row>
                            </div>



                        </v-col>


                        <v-col>

                            <div style="margin-left: 20px; margin-right:20px; margin-top:20px">

                                <v-row>
                                    <span class="font-weight-bold type-label-style">Lesiones</span>
                                </v-row>

                                <v-row style="margin-top:15px;">
                                    <span class="type-label-style">Tipo de Documento:</span>


                                </v-row>

                                <v-row style="margin-top:15px;">


                                    <v-select return-object
                                              solo
                                              :items="docsLesiones"
                                              v-model="lesionSelected"
                                              item-text="dodescrip"
                                              item-value="doclave"
                                              placeholder="Seleccione Documento"
                                              :disabled="documentosBlock"
                                              :filled="documentosBlock">
                                    </v-select>
                                </v-row>


                                <v-row style="margin-top:15px;">
                                    <span class="type-label-style">Número de pases:</span>


                                </v-row>

                                <v-row style="margin-top:15px;">
                                    <v-text-field class="align-left-button"
                                                  v-model="lesionesDatos.numPases"
                                                  v-on:blur="datos.nombre = datos.nombre != null ? datos.nombre.trim() : null"
                                                  outlined
                                                  @keypress="filterNumbers()"
                                                  maxlength="5"
                                                  dense
                                                  oninput="if(this.value == 0) this.value = null;"
                                                  :disabled="lesionesBlocked"
                                                  :filled="lesionesBlocked"
                                                  :error-messages="validation.numPases">
                                    </v-text-field>


                                </v-row>

                                <v-row style="margin-top:15px;">
                                    <span class="type-label-style">Monto por documento:</span>


                                </v-row>

                                <v-row style="margin-top:15px;">
                                    <v-text-field class="align-left-button"
                                                  v-model="lesionesDatos.montoLesionesdocto"
                                                  @keypress="filter()"
                                                  outlined
                                                  dense
                                                  maxlength="12"
                                                  oninput="if(this.value == 0) this.value = null;"
                                                  :error-messages="validation.montoLesionesdocto"
                                                  :disabled="disabledmontoLesiones"
                                                  :filled="disabledmontoLesiones">
                                    </v-text-field>


                                </v-row>

                                <v-row style="margin-top:15px;">
                                    <span class="type-label-style">Monto Total de documento(s):</span>


                                </v-row>

                                <v-row style="margin-top:15px;">
                                    <v-text-field class="align-left-button"
                                                  v-model="lesionesDatos.montoLesiones"
                                                  outlined
                                                  dense
                                                  :disabled="true"
                                                  :filled="true">
                                    </v-text-field>


                                </v-row>


                                <v-row style="margin-top:15px;">
                                    <span class="type-label-style">Folio:</span>


                                </v-row>

                                <v-row style="margin-top:15px;">
                                    <v-text-field class="align-left-button"
                                                  v-model="lesionesDatos.folioLesiones"
                                                  v-on:blur="lesionesDatos.folioLesiones = lesionesDatos.folioLesiones != null ? lesionesDatos.folioLesiones.trim() : null"
                                                  outlined
                                                  maxlength="30"
                                                  dense
                                                  :disabled="lesionesBlocked"
                                                  :filled="lesionesBlocked"
                                                  :error-messages="validation.folioLesiones">
                                    </v-text-field>


                                </v-row>






                            </div>



                        </v-col>
                    </v-row>

                    <span style="color: red;" v-show="validaDocs">Seleccione al menos un tipo de documento</span>


                    <v-row v-if="datosDocs.nrfoliodanios == null && datosDocs.nrfoliolesiones == null" justify="center">
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <!--<v-btn color="#536DFE" dark v-on:click="saveMovimientoProcess()">Guardar</v-btn>-->

                            <v-btn class="ma-2"
                                   color="primary"
                                   title="Guardar"
                                   @click="guardarDocs(3)"
                                   :disabled="disBtn">
                                <span style="color: white">Guardar</span>
                            </v-btn>

                            <v-btn class="ma-2" v-on:click="clearOptionsDoc()">
                                <span style="color: black">Limpiar</span>
                            </v-btn>

                            <v-spacer></v-spacer>
                        </v-card-actions>
                    </v-row>

                </v-card-text>
            </v-form>
        </v-card>

        <v-card v-if="validacionEstadistico == 0 && detallePago == false" elevation="6" class="base-card-container pa-0 mt-4">
            <v-card-title class="pa-5 pb-3 primary">
                <v-icon class="pr-4" :color="'#FFFFFF'">mdi-square-inc-cash</v-icon>
                <p style="color: white;">Alta Movimientos</p>

            </v-card-title>
            <v-form>
                <v-card-text>

                    <v-row justify="center">
                        <v-col cols="6">

                            <div style="margin-top:15px;">

                                <v-row style="margin-top: 15px;">
                                    <span class="type-label-style">Tipo de Movimiento:</span>
                                </v-row>


                                <v-row v-if="confirmarPago">
                                    <span class="font-weight-bold type-label-style">Confirmación de Pago</span>
                                </v-row>

                                <v-row v-if="!confirmarPago">
                                    <v-select return-object
                                              solo
                                              :items="catalogoMov"
                                              v-model="movSelect"
                                              item-text="mrconcepto"
                                              item-value="mrid"
                                              placeholder="Seleccione Movimiento"
                                              :rules="ruleSelect"
                                              ref="movSelect">
                                    </v-select>
                                </v-row>

                            </div>



                        </v-col>
                    </v-row>

                    <v-row v-if="confirmarPago" justify="center">
                        <v-col cols="6">

                            <div style="margin-top:15px;">

                                <v-row style="margin-top: 15px;">
                                    <span class="type-label-style">Número de Pago:</span>
                                </v-row>

                                <v-row style="margin-top: 15px;">
                                    <span class="font-weight-bold type-label-style">{{datosPago.numero}}</span>
                                </v-row>

                            </div>



                        </v-col>
                    </v-row>



                    <v-row v-if="confirmarPago" justify="center">
                        <v-col cols="6">

                            <div style="margin-top:15px;">

                                <v-row style="margin-top: 15px;">
                                    <span class="type-label-style">Monto a Pagar:</span>
                                </v-row>

                                <v-row>
                                    <v-text-field class="align-left-button"
                                                  v-model="datosPago.montoPago"
                                                  outlined
                                                  :error-messages="validation.montoPago"
                                                  @keypress="filter()"
                                                  maxlength="8"
                                                  dense>
                                    </v-text-field>
                                </v-row>

                            </div>



                        </v-col>
                    </v-row>



                    <v-row v-if="confirmarPago" justify="center">
                        <v-col cols="6">

                            <div style="margin-top:15px;">

                                <v-row style="margin-top: 15px;">
                                    <span class="type-label-style">Forma de Pago:</span>
                                </v-row>

                                <v-row>
                                    <v-checkbox v-model="formPago.efectivo"
                                                label="Efectivo"
                                                style="margin: 0px"
                                                hide-details></v-checkbox>
                                </v-row>

                                <v-row v-if="formPago.efectivo == true" style="margin-top: 15px;">
                                    <span class="type-label-style">Monto de Efectivo:</span>
                                </v-row>

                                <v-row v-if="formPago.efectivo == true">
                                    <v-text-field class="align-left-button"
                                                  v-model="datosPago.montoEfec"
                                                  v-on:blur="datosPago.montoEfec = datosPago.montoEfec != null ? datosPago.montoEfec.trim() : null"
                                                  outlined
                                                  @keypress="filter()"
                                                  :error-messages="validation.montoEfec"
                                                  maxlength="8"
                                                  dense>
                                    </v-text-field>
                                </v-row>

                                <v-row>
                                    <v-checkbox v-model="formPago.cheque"
                                                label="Cheque"
                                                style="margin: 0px"
                                                hide-details></v-checkbox>
                                </v-row>


                                <v-row v-if="formPago.cheque == true" style="margin-top: 15px;">
                                    <span class="type-label-style">Monto de Cheque:</span>
                                </v-row>

                                <v-row v-if="formPago.cheque == true">
                                    <v-text-field class="align-left-button"
                                                  v-model="datosPago.montoCheque"
                                                  v-on:blur="datosPago.montoCheque = datosPago.montoCheque != null ? datosPago.montoCheque.trim() : null"
                                                  outlined
                                                  @keypress="filter()"
                                                  :error-messages="validation.montoCheque"
                                                  maxlength="8"
                                                  dense>
                                    </v-text-field>
                                </v-row>

                                <v-row>
                                    <v-checkbox v-model="formPago.especia"
                                                label="Especie"
                                                style="margin: 0px"
                                                hide-details></v-checkbox>
                                </v-row>

                                <v-row v-if="formPago.especia == true" style="margin-top: 15px;">
                                    <span class="type-label-style">Monto de especie:</span>
                                </v-row>

                                <v-row v-if="formPago.especia == true">
                                    <v-text-field class="align-left-button"
                                                  v-model="datosPago.montoEspecie"
                                                  v-on:blur="datosPago.montoEspecie = datosPago.montoEspecie != null ? datosPago.montoEspecie.trim() : null"
                                                  outlined
                                                  :error-messages="validation.montoEspecie"
                                                  @keypress="filter()"
                                                  maxlength="8"
                                                  dense>
                                    </v-text-field>
                                </v-row>

                                <v-row v-if="formPago.especia == true" style="margin-top: 15px;">
                                    <span class="type-label-style">Descripción de especie:</span>
                                </v-row>

                                <v-row v-if="formPago.especia == true">
                                    <v-text-field class="align-left-button"
                                                  v-model="datosPago.descEspecie"
                                                  v-on:blur="datosPago.descEspecie = datosPago.descEspecie != null ? datosPago.descEspecie.trim() : null"
                                                  outlined
                                                  :error-messages="validation.descEspecie"
                                                  maxlength="30"
                                                  dense>
                                    </v-text-field>
                                </v-row>
                            </div>
                            <br />
                            <span style="color: red;" v-show="validaPago">Seleccione al menos una opción</span>


                        </v-col>
                    </v-row>


                    <v-row justify="center">

                        <v-col cols="6">


                            <div>


                                <v-row>
                                    <span class="type-label-style">Fecha del movimiento:</span>
                                </v-row>

                                <v-row>
                                    <v-dialog ref="dialog"
                                              outlined
                                              v-model="modal"
                                              :return-value.sync="selectedDate"
                                              persistent
                                              width="290px">
                                        <template v-slot:activator="{ on, attrs }">
                                            <div class="date-align-center" style="width:100%">
                                                <v-text-field v-model="selectedDate"
                                                              label=""
                                                              readonly
                                                              :rules="rulestextfechas"
                                                              outlined
                                                              dense
                                                              v-bind="attrs"
                                                              v-on="on"
                                                              :error-messages="validation.errorFecha"
                                                              ref="selectedDate"></v-text-field>
                                            </div>
                                        </template>
                                        <v-date-picker v-model="selectedDate"
                                                       locale="es-mx"
                                                       :max="maxDate"
                                                       :min="minDate"
                                                       scrollable>
                                            <v-spacer></v-spacer>
                                            <v-btn text color="primary" @click="modal = false">
                                                Cancel
                                            </v-btn>
                                            <v-btn text
                                                   color="primary"
                                                   @click="$refs.dialog.save(selectedDate)">
                                                OK
                                            </v-btn>
                                        </v-date-picker>
                                    </v-dialog>
                                </v-row>




                            </div>

                        </v-col>



                    </v-row>

                    <v-row justify="center" v-if="autorizacion == true">
                        <v-col cols="6">

                            <div style="margin-top:15px;">

                                <v-row>
                                    <span class="type-label-style">Firma Electronica</span>
                                </v-row>

                                <v-row>
                                    <v-text-field outlined
                                                  dense
                                                  required
                                                  maxlength="17"
                                                  style="-webkit-text-security: disc;"
                                                  v-model="firma"
                                                  ref="firma">
                                    </v-text-field>

                                </v-row>

                                <v-row>
                                    <span style="color: red;" v-show="validafirma">{{texto}}</span>
                                </v-row>

                            </div>



                        </v-col>
                    </v-row>

                    <v-row justify="center">

                        <v-col cols="6">

                            <div>

                                <v-row style="margin-top: 15px;">
                                    <span class="type-label-style">Observaciones:</span>
                                </v-row>

                                <v-row>


                                    <v-textarea id="textareaobs"
                                                v-on:blur="observacionesSelected = observacionesSelected != null ? observacionesSelected.trim() : null"
                                                v-model="observacionesSelected"
                                                class="textarea"
                                                outlined
                                                :rules="rulestextarea"
                                                ref="observacionesSelected">

                                    </v-textarea>



                                </v-row>
                            </div>



                        </v-col>

                    </v-row>

                    <v-row justify="center">
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <!--<v-btn color="#536DFE" dark v-on:click="saveMovimientoProcess()">Guardar</v-btn>-->

                            <v-btn class="ma-2"
                                   color="primary"
                                   title="Guardar"
                                   @click="guardarMovimiento()"
                                   :disabled="disBtn">
                                <span style="color: white">Guardar</span>
                            </v-btn>

                            <v-btn :disabled="disBtn" class="ma-2" v-on:click="clearOptionsMov()">
                                <span style="color: black">Limpiar</span>
                            </v-btn>
                            <v-btn :disabled="disBtn" class="ma-2" color="#FF4081" v-on:click="$router.push({ name: 'SeguimientoRecuperaciones' }).catch((error) => error);">
                                <span style="color: white">Cancelar</span>
                            </v-btn>
                            <v-spacer></v-spacer>
                        </v-card-actions>
                    </v-row>

                </v-card-text>
            </v-form>
        </v-card>

        <v-card v-if="detallePago == true && confirmarPago == true" elevation="6" class="base-card-container pa-0 mt-4">
            <v-card-title class="pa-5 pb-3 primary">
                <v-icon class="pr-4" :color="'#FFFFFF'">mdi-square-inc-cash</v-icon>
                <p style="color: white;">Detalle de pago</p>

            </v-card-title>
            <v-form>
                <v-card-text>

                    <v-row justify="center">
                        <v-col cols="6">

                            <div style="margin-top:15px;">

                                <v-row style="margin-top: 15px;">
                                    <span class="type-label-style">Tipo de Movimiento:</span>
                                </v-row>


                                <v-row v-if="confirmarPago">
                                    <span class="font-weight-bold type-label-style">Confirmación de Pago</span>
                                </v-row>

                            </div>



                        </v-col>
                    </v-row>

                    <v-row v-if="confirmarPago" justify="center">
                        <v-col cols="6">

                            <div style="margin-top:15px;">

                                <v-row style="margin-top: 15px;">
                                    <span class="type-label-style">Número de Pago:</span>
                                </v-row>

                                <v-row style="margin-top: 15px;">
                                    <span class="font-weight-bold type-label-style">{{datosPagado.numero}}</span>
                                </v-row>

                            </div>



                        </v-col>
                    </v-row>

                    <v-row v-if="confirmarPago" justify="center">
                        <v-col cols="6">

                            <div style="margin-top:15px;">

                                <v-row style="margin-top: 15px;">
                                    <span class="type-label-style">Forma de Pago:</span>
                                </v-row>

                                <v-row v-if="datosPagado.efectivo == true">
                                    <v-checkbox v-model="datosPagado.efectivo"
                                                label="Efectivo"
                                                style="margin: 0px; font-size:18px"
                                                disabled
                                                class="font-weight-bold"
                                                hide-details></v-checkbox>
                                </v-row>

                                <v-row v-if="datosPagado.efectivo == true" style="margin-top: 30px;">
                                    <span class="type-label-style">Monto de Efectivo:</span>
                                </v-row>

                                <v-row v-if="datosPagado.efectivo == true" style="font-size:18px">

                                    <span class="font-weight-bold type-label-style">${{this.datosPagado.montoEfec}}</span>

                                </v-row>

                                <v-row v-if="datosPagado.cheque == true" style="margin-top: 30px;">
                                    <v-checkbox v-model="datosPagado.cheque"
                                                label="Cheque"
                                                style="margin: 0px; font-size:18px"
                                                disabled
                                                class="font-weight-bold"
                                                hide-details></v-checkbox>
                                </v-row>


                                <v-row v-if="datosPagado.cheque == true" style="margin-top: 15px;">
                                    <span class="type-label-style">Monto de Cheque:</span>
                                </v-row>

                                <v-row v-if="datosPagado.cheque == true" style="font-size:18px">

                                    <span class="font-weight-bold type-label-style">${{this.datosPagado.montoCheque}}</span>

                                </v-row>

                                <v-row v-if="datosPagado.especia == true" style="margin-top: 30px;">
                                    <v-checkbox v-model="datosPagado.especia"
                                                label="Especie"
                                                style="margin: 0px; font-size:18px"
                                                disabled
                                                class="font-weight-bold"
                                                hide-details></v-checkbox>
                                </v-row>

                                <v-row v-if="datosPagado.especia == true" style="margin-top: 30px;">
                                    <span class="type-label-style">Monto de especie:</span>
                                </v-row>

                                <v-row v-if="datosPagado.especia == true" style="font-size:18px">

                                    <span class="font-weight-bold type-label-style">${{this.datosPagado.montoEspecie}}</span>


                                </v-row>

                                <v-row v-if="datosPagado.especia == true" style="margin-top: 30px;">
                                    <span class="type-label-style">Descripción de especie:</span>
                                </v-row>

                                <v-row v-if="datosPagado.especia == true" style="font-size:18px">
                                    <span class="font-weight-bold type-label-style">{{this.datosPagado.descEspecie}}</span>

                                </v-row>

                                <v-row style="margin-top: 30px;">
                                    <span class="type-label-style">Fecha del movimiento:</span>
                                </v-row>

                                <v-row style="font-size:18px">

                                    <span class="font-weight-bold type-label-style">{{this.datosPagado.fechaPago}}</span>

                                </v-row>

                                <v-row style="margin-top: 30px;">
                                    <span class="type-label-style">Observaciones:</span>
                                </v-row>

                                <v-row style="font-size: 18px; margin-bottom: 25px;">

                                    <span class="font-weight-bold type-label-style">{{this.datosPagado.obsPago}}</span>

                                </v-row>

                            </div>

                        </v-col>
                    </v-row>



                </v-card-text>
            </v-form>
        </v-card>

        <v-card elevation="6" class="base-card-container pa-0 mt-4">
            <v-card-title class="pa-5 pb-3 primary">
                <v-icon class="pr-4" :color="'#FFFFFF'">mdi-square-inc-cash</v-icon>
                <p style="color: white;">
                    Listado Movimientos
                </p>

            </v-card-title>
            <v-form>
                <v-card-text>
                    <v-row v-if="showTable" justify="center">
                        <v-col cols="12">
                            <DataTable :url="urlMovimientos"
                                       :columns="columnsMovimientos"
                                       :params="displayInputsPago"
                                       :order="[]"
                                       :formatterActions="formatterActions"
                                       @apiDT="apiDTMovimientos = $event"></DataTable>



                        </v-col>
                    </v-row>



                </v-card-text>
            </v-form>
        </v-card>

        <div>

            <v-dialog v-model="modalFecha" scrollable persistent content-class="dialogShareClass"
                      transition="dialog-bottom-transition">
                <template>
                    <v-card>
                        <v-card-title class="justify-center primary">
                            <v-toolbar-title id="titulocard">Registrar</v-toolbar-title>
                        </v-card-title>

                        <v-card-text>
                            <v-row>
                                <v-col cols="12" col-md="8" class="text-center">
                                    <span style="margin-bottom: 20%;">
                                        Ingrese la fecha estimada para el siguiente pago de:{{this.totSpan}}
                                    </span>
                                    <br />

                                    <span style="margin-top: 20% !important;" class="files-report-label-style">Fecha estimada:</span>
                                    <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false"
                                            transition="scale-transition" offset-y max-width="290px"
                                            min-width="auto">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field v-model="dateFormatted" class="centerInputs" outlined
                                                          readonly v-bind="attrs" @blur="date = dateFormatted" v-on="on"
                                                          style="margin-top: 2%;"></v-text-field>
                                        </template>
                                        <v-date-picker v-model="dateFormatted" locale="es-mx"
                                                       :min="minDate" @input="menu1 = false">
                                        </v-date-picker>
                                    </v-menu>
                                </v-col>
                                <v-col class="text-center">
                                    <span style="color: red;" v-if="spanModal">
                                        Seleccione una fecha
                                    </span>
                                </v-col>
                            </v-row>
                        </v-card-text>
                        <v-card-actions class="justify-center">
                            <!--<v-btn color="primary" @click="CompartirVideo(usuarios.usid)"
                                   :disabled="buttonCompartir">
                                Compartir
                            </v-btn>-->

                            <v-btn color="primary" :loading="loading" @click="PagoModal()"
                                   :disabled="loading">Aceptar</v-btn>


                        </v-card-actions>
                    </v-card>
                </template>
            </v-dialog>


        </div>
    </v-container>
</template>




<script>
    import MetodosGenerales from '@/utils/metodosgenerales.vue.js';
    import { mapActions, mapMutations, mapState, mapGetters } from "vuex";
    import DataTable from "@/components/pages/DataTableNet/DataTable";
    import moment from 'moment'
    import SerBusqueda from '@/services/Busqueda/Busqueda.service.js';
    import reporteGeneral from "@/services/ReporteGeneral/ReporteGeneral.service.js";
    import Recuperaciones from '@/services/Recuperaciones/Recuperaciones.service.js';
    import Menu from '@/components/pages/Contraloria/MenuRecuperaciones/MenuRecup.vue';

    export default {
        components: {
            DataTable,
            Menu
        },
        data() {
            return {
                showTable: false,
                nombreArchivo: '',
                showcargando: true,
                conclusion: false,
                urlPago: "Recuperaciones/ObtenerRecuperacionesPagos",
                displayInputsPago: {
                    nrid: null,
                    nrtippago: null,
                },
                apiDTPago: null,
                columnsPago: [

                    { name: 'dfnumpago', data: 'dfnumpago', title: "No. Pago " },
                    { name: 'dfmontoLBL', data: 'dfmontoLBL', title: "Monto Pago" },
                    { name: 'dffhpagoestimado', data: 'dffhpagoestimado', title: "Fecha Estimado de Pago" },
                    { name: 'dffhpago', data: 'dffhpago', title: "Fecha de Pago" },
                ],
                apiDTPagoDif: null,
                columnsPagoDif: [

                    { name: 'd3nombre', data: 'd3nombre', title: "No. Pago " },
                    { name: 'nrmontoneg', data: 'nrmontoneg', title: "Monto Pago" },
                    { name: 'nrfhalta', data: 'nrfhalta', title: "Fecha Estimado de Pago" },
                    { name: 'nrobs', data: 'nrobs', title: "Fecha de Pago" },
                ],
                urlMovimientos: "Recuperaciones/ObtenerMovimientosRecuperacion",
                columnsMovimientos: [

                    { name: 'dfnumpago', data: 'dfnumpago', title: "No. Pago", formatter: [this, "nullForm"] },
                    { name: 'nsfhfecha', data: 'nsfhfecha', title: "Fecha" },
                    { name: 'nsfhalta', data: 'nsfhalta', title: "Fecha Movimiento" },
                    { name: 'mrconcepto', data: 'mrconcepto', title: "Tipo Movimiento" },
                    { name: 'nsobs', data: 'nsobs', title: "Observaciones" },
                ],
                displayInputsMovimientos: {
                    nrid: null,
                    nrtippago: null,
                },
                apiDTMovimientos: null,

                formatterActions: [
                    { click: [this, "BuscarDetalleRep"] },
                ],
                agregarDocs: false,
                modal: false,
                modalFecha: false,
                listado: '',
                overlay: false,
                validacionEstadistico: null,
                datosDocs: null,
                catalogoMov: null,
                movSelect: null,
                minDate: null,
                maxDate: null,
                datosReporte: null,
                datos: null,
                selectedDate: null,
                observacionesSelected: null,
                rulestext: [
                    //v => !!v || 'Campo requerido',
                    (v) => {
                        if (v == null || v == "") {
                            return "Campo requerido";
                        }
                    },
                ],
                rulestextfechas: [(v) => !!v || "Campo requerido"],
                ruleSelect: [(v) => !!v || "Campo requerido"],
                rulestextarea: [
                    //v => !!v || 'Campo requerido',
                    (v) => {
                        if (v == null) {
                            return true;
                        }
                        else if (v == "") {
                            return "Campo requerido";
                        } else {
                            if (v.trim().length < 12) {
                                return "Mínimo 12 Carácteres";
                            } else if (v.trim().length > 500) {
                                return "Máximo 500 Carácteres";
                            } else {
                                return true;
                            }
                        }
                    },
                ],
                disBtn: false,
                autorizacion: false,
                firma: '',
                validafirma: false,
                texto: '',
                formPago: {
                    efectivo: false,
                    efectivoText: null,
                    cheque: false,
                    chequeText: null,
                    especia: false,
                    especiaText: null,
                    especiaDesc: null,
                },
                confirmarPago: false,
                docsDanos: [],
                docsLesiones: [],
                danoSelected: null,
                lesionSelected: null,
                danosBlocked: true,
                lesionesBlocked: true,
                aseguradoras: null,
                asegSelected: null,
                danosDatos: {
                    montoDanos: null,
                    folioDanos: null,
                    obsDanos: null,
                },
                lesionesDatos: {
                    numPases: null,
                    montoLesionesdocto:null,
                    montoLesiones: null,
                    folioLesiones: null,
                },
                datosPago: {
                    numero: '',
                    montoPago: null,
                    montoEfec: null,
                    montoCheque: null,
                    montoEspecie: null,
                    descEspecie: null,

                },
                documentosBlock: false,
                asegBlock: false,
                datosRecuperaciones: null,
                validaDocs: false,
                validation: {

                    errorObsMov: '',
                    errorMovSelect: '',
                    errorFecha: '',

                    //Docs
                    errorMontoDanos: '',
                    errorObsDocs: '',
                    folioDanos: '',
                    asegSelected: '',

                    //Lesiones
                    numPases: '',
                    folioLesiones: '',

                    //Pagos
                    montoPago: '',
                    montoEfec: '',
                    montoCheque: '',
                    montoEspecie: '',
                    descEspecie: '',
                },
                validaPago: false,
                movPago: {
                    numeropago: null,
                    montoneg: null,
                    idpago: null,
                },
                loading: false,
                menu1: false,
                dateFormatted: null,
                spanModal: false,
                totSpan: '',
                datosPagado: {
                    fechaPago: '',
                    obsPago: '',
                    numero: '',
                    montoPago: null,
                    montoEfec: null,
                    montoCheque: null,
                    montoEspecie: null,
                    descEspecie: null,
                    efectivo: false,
                    efectivoText: null,
                    cheque: false,
                    chequeText: null,
                    especia: false,
                    especiaText: null,
                    especiaDesc: null,
                },
                detallePago: false,
                pagoFecha: 0,
                nrmontoneg: 0,
                disabledmontoLesiones: true,

            }
        },
        computed: {
            ...mapState(["domain", "informationPage", "permission"]),
        },
        methods: {
            filterNumbers: function (evt) {
                evt = (evt) ? evt : window.event;
                let expect = evt.target.value.toString() + evt.key.toString();
                if (!/^[0-9]*$/.test(expect)) {
                    evt.preventDefault();
                } else {
                    return true;
                }
            },
            filter: function (evt) {
                evt = (evt) ? evt : window.event;
                let expect = evt.target.value.toString() + evt.key.toString();
                if (expect=='.') {
                    evt.preventDefault();
                    return false;
                }
                if (!/^[0-9]*\.?[0-9]*$/.test(expect)) {
                    evt.preventDefault();
                } else {
                    return true;
                }
            },
            async fetchData() {
                const response = this.listado;
                return response;
            },
            reloadTable() {
                if (this.apiDT != null) {
                    this.apiDT.ajax.reload(null, false);
                    this.apiDT.columns.adjust().responsive.recalc();
                }

            },
            reloadTableRunning() {
                this.apiDT.ajax.reload(null, false);
                //this.apiDT.columns.adjust().responsive.recalc();
                this.apiDTMovimientos.ajax.reload(null, false);
                //this.apiDT.apiDTMovimientos.adjust().responsive.recalc();
            },
            clearOptionsMov() {

                this.confirmarPago = false;

                for (var i = 0; i < this.catalogoMov.length; i++) {

                    if (this.catalogoMov[i]["mrid"] == 2) {
                        this.movSelect = this.catalogoMov[i];
                    }
                }

                this.selectedDate = this.maxDate;
                this.firma = '';
                this.observacionesSelected = null;

                this.formPago.efectivo = null;
                this.datosPago.montoEfec = null;

                this.formPago.especia = null;
                this.datosPago.montoCheque = null;

                this.formPago.cheque = null;
                this.datosPago.montoEspecie = null;
                this.datosPago.descEspecie = null;

                this.autorizacion = false;
            },
            clearOptionsDoc() {

                this.danoSelected = null;
                this.danosDatos.montoDanos = null;
                this.danosDatos.folioDanos = null;

                this.asegSelected = null;
                this.danosDatos.obsDanos = null;
                this.lesionSelected = null;
                this.lesionesDatos.numPases = null;

                this.lesionesDatos.montoLesionesdocto = null;

                this.lesionesDatos.montoLesiones = null;

                this.lesionesDatos.folioLesiones = null;

                this.asegSelected = this.aseguradoras[0];

                this.validation.errorMontoDanos = '';
                this.validation.errorObsDocs = '';
                this.validation.folioDanos = '';
                this.validation.asegSelected = '';
                this.validation.numPases = '';
                this.validation.montoLesionesdocto = '';
                this.validation.errorObsDocs = '';
                this.validation.folioLesiones = '';
                this.validaDocs = false;

                this.agregarDocs = false;
                this.disabledmontoLesiones = true;
            },
            mostrarMov(datos) {

                this.movSelect = null;
                this.selectedDate = this.maxDate;
                this.firma = '';
                this.observacionesSelected = null;

                this.formPago.efectivo = null;
                this.datosPago.montoEfec = null;

                this.formPago.especia = null;
                this.datosPago.montoCheque = null;

                this.formPago.cheque = null;
                this.datosPago.montoEspecie = null;
                this.datosPago.descEspecie = null;



                if (datos == null) {

                    this.confirmarPago = false;
                    this.detallePago = false;
                    this.agregarDocs = false;
                }
                else {



                    this.datosPago.numero = datos.dfnumpago;
                    this.datosPago.montoPago = datos.dfmonto;

                    this.confirmarPago = true;

                    this.movPago.idpago = null;
                    this.movPago.numeropago = null;
                    this.movPago.montoneg = null;


                    this.cambiarMovimiento(datos.dfid, datos.dfnumpago, datos.dfmonto, datos.dffhpago)
                }

            },
            async cambiarMovimiento(dfid, dfnumpago, dfmonto, dffhpago) {


                this.agregarDocs = false;



                if (this.movPago.idpago != dfid) {
                    this.movPago.idpago = "";
                    //valiase = "";
                }

                if (this.movPago.idpago == "") {


                    this.movPago.idpago = dfid;
                    this.movPago.numeropago = dfnumpago;
                    this.movPago.montoneg = dfmonto;

                    if (dffhpago != '' && dffhpago != null) {

                        this.movPago.idpago = dfid;

                        //ObtenerDetallePago

                        await Recuperaciones.ObtenerDetallePago(dfid).then(response => {

                            this.detallePago = true;


                            var pagoDatos = response[0];

                            this.datosPagado.numero = pagoDatos.dfnumpago;
                            this.datosPagado.efectivo = pagoDatos.nsefectivo == 'True' ? true : false;
                            this.datosPagado.montoEfec = pagoDatos.nsmontoefectivo;

                            this.datosPagado.cheque = pagoDatos.nscheque == 'True' ? true : false;
                            this.datosPagado.montoCheque = pagoDatos.nsmontocheque;

                            this.datosPagado.especia = pagoDatos.nsespecie == 'True' ? true : false;
                            this.datosPagado.montoEspecie = pagoDatos.nsmontoespecie;
                            this.datosPagado.descEspecie = pagoDatos.nsdescespecie;

                            this.datosPagado.fechaPago = pagoDatos.nsfhalta;

                            this.datosPagado.obsPago = pagoDatos.nsobs;



                        });
                    }
                    else {
                        this.detallePago = false;
                    }


                }


            },
            async agregarDocumentos() {

                this.agregarDocs = true;

                if (this.documentosBlock == false) {

                    this.danoSelected = null;
                    this.danosDatos.montoDanos = null;
                    this.danosDatos.folioDanos = null;

                    this.danosDatos.obsDanos = null;
                    this.lesionSelected = null;
                    this.lesionesDatos.numPases = null;

                    this.lesionesDatos.montoLesionesdocto = null;

                    this.lesionesDatos.montoLesiones = null;

                    this.lesionesDatos.folioLesiones = null;

                    this.disabledmontoLesiones = true;
                }




                var docs = await Recuperaciones.ObtenerDocumentosDanos();

                for (var i = 0; i < docs.length; i++) {



                    if (docs[i]["doclave"] == 28) {
                        this.docsLesiones.push(docs[i]);


                        if (this.datosDocs.nrpasemedico == 1) {
                            this.lesionSelected = docs[i];
                        }
                    }
                    else {
                        this.docsDanos.push(docs[i]);
                    }


                    if (this.datosDocs.nrfoliodanios != null || this.datosDocs.nrfoliolesiones != null) {


                        if (docs[i]["doclave"] == this.datosDocs.doclave) {

                            this.danoSelected = docs[i];


                        }

                    }

                }


                var resp = await Recuperaciones.ObtenerValidacionAseg(this.datos.nrid);

                this.aseguradoras = await Recuperaciones.ObtenerAseguradoras();

                if (resp != null && resp.length > 0) {

                    if (resp[0].aseclave != 0) {
                        this.aseguradoras = resp;
                        this.asegBlock = true;
                        this.asegSelected = resp[0];
                    } else {
                        this.asegSelected = resp[0];
                    }

                }
                else {
                    this.asegSelected = this.aseguradoras[0];
                }








            },

            //InsertarMovimientoConfPago
            async BuscarDetalleRep(params, item, fila) {

                let reporte = {
                    nrreporte: item.Reporte,
                    svindice: item.Indice,
                    aiclave: item.aiclave,
                    svfhconclusion: item.svfhconclusion
                };

                var ver = 0;
                let formData = new FormData();
                formData.append("nrreporte", item.Reporte);
                formData.append("svindice", item.Indice);
                await SerBusqueda.ObtenerValidacion(this, formData).then(data => {
                    ver = data;
                });

                if (ver == 0) {
                    this.$router.push({ name: `${"DatosIncompletos"}` });
                }
                else {

                    let routerName = MetodosGenerales.obtenerRouterName(item.aiclave.toString());

                    await MetodosGenerales.guardarEnSesionInfoReporte(reporte, 'reporte');
                    let url = this.$router.resolve({ name: `${routerName}` });

                    window.open(url.href, '_blank');

                }
            },

            reporteForm(datos) {
                if ((datos.aiclave == 1 || datos.aiclave == 23 || datos.aiclave == 24 || datos.aiclave == 5)) {

                    return `<div class="ml-4"><button type="button" class="mr-1 dt-formatterAction" aria-haspopup="true" data-action="0" data-params="${datos}" aria-expanded="false"><span class='reporteindice'>${datos.nrreporte}-${datos.svindice}</span></button></div>`;
                } else {
                    return `<span>${datos.nrreporte}-${datos.svindice}</span>`;
                }
            },

            nullForm(datos) {

                if (typeof datos.dfnumpago === 'object') {

                    return ``;
                } else {
                    return `<span>${datos.dfnumpago}</span>`;
                }
            },
            vigenciaForm(datos) {

                if (datos.dffhpagoestimado == "1") {

                    return ``;
                }
                if (datos.dffhpagoestimado == "3") {

                    return `<div class="ml-4"><span title="A 1 semana de vencer" style="background-color:#F1F90F;" class="dot"></span></div>`;
                }
                if (datos.dffhpagoestimado == "2") {

                    return `<div class="ml-4"><span title="A 1 día de vencer" style="background-color:#FABC08;" class="dot"></span></div>`;
                }
                if (datos.dffhpagoestimado == "4") {

                    return `<div class="ml-4"><span title="Vencido" style="background-color:#F72D0D;" class="dot"></span></div>`;
                }
                if (datos.dffhpagoestimado == "5") {
                    return ``;
                }


            },
            async guardarMovimiento() {

                if (this.confirmarPago == true) {
                    this.guardarPago();
                }

                if (this.movSelect != null) {
                    if (this.movSelect.mrid == 3) //Es conclusión
                    {


                        var valid = await this.validGral(2);


                        if (this.firma.length < 8 || this.firma.length > 17) {

                            this.validafirma = true;
                            this.texto = 'El número de caracteres debe ser un mínimo de 8 y menor a 17';
                            return;
                        }

                        var validFirm = await Recuperaciones.ValidaFirmaElectronica(this.datos.nrreporte, this.datos.svindice, this.firma);



                        if (!validFirm) {
                            this.validafirma = true;
                            this.texto = 'Su firma electrónica es incorrecta';

                        }


                        if (valid == true && validFirm == true) {

                            this.disBtn = true;

                            this.$swal({
                                position: 'center',
                                title: 'Guardando datos...',
                                allowEscapeKey: false,
                                allowOutsideClick: false,
                                didOpen: () => {
                                    this.$swal.showLoading();
                                }


                            });

                            var formData = new FormData();
                            formData.append("sumaMontos", this.datosRecuperaciones.sumaMontos);
                            formData.append("nrid", this.datos.nrid);
                            formData.append("mrid", this.movSelect.mrid);
                            formData.append("nsfhalta", this.selectedDate);
                            formData.append("nsobs", this.observacionesSelected);

                            //var resp = await Recuperaciones.InsertarMovimientoConfPago(formData);

                            await Recuperaciones.InsertarMovimientoConfPago(formData).then(response => {



                                setTimeout(() => {
                                    this.$swal.close();
                                    if (response) {



                                        this.$swal({
                                            position: 'center',
                                            icon: 'success',
                                            title: 'Éxito',
                                            text: 'Se guardaron los datos correctamente',
                                            showConfirmButton: true,
                                            allowOutsideClick: false,
                                            timer: 2500,
                                        }).then(async () => {

                                            await this.reloadPage();
                                            //location.reload();
                                            this.disBtn = false;
                                        });

                                    }
                                    else {
                                        this.$swal({
                                            position: 'center',
                                            icon: 'error',
                                            title: 'Error',
                                            text: 'Hubo un error al guardar los datos, Favor de avisar a Desarrollo',
                                            showConfirmButton: true,
                                            allowOutsideClick: false,
                                        })
                                    }
                                }, 2000);

                            });
                        }



                    }
                    else {




                        var valid = await this.validGral(1);

                        if (valid == true) {

                            this.disBtn = true;

                            this.$swal({
                                position: 'center',
                                title: 'Guardando datos...',
                                allowEscapeKey: false,
                                allowOutsideClick: false,
                                didOpen: () => {
                                    this.$swal.showLoading();
                                }


                            });

                            var formData = new FormData();
                            formData.append("sumaMontos", this.datosRecuperaciones.sumaMontos);
                            formData.append("nrid", this.datos.nrid);
                            formData.append("mrid", this.movSelect.mrid);
                            formData.append("nsfhalta", this.selectedDate);
                            formData.append("nsobs", this.observacionesSelected);

                            //var resp = await Recuperaciones.InsertarMovimientoConfPago(formData);



                            await Recuperaciones.InsertarMovimientoConfPago(formData).then(response => {



                                setTimeout(() => {
                                    this.$swal.close();
                                    if (response) {



                                        this.$swal({
                                            position: 'center',
                                            icon: 'success',
                                            title: 'Éxito',
                                            text: 'Se guardaron los datos correctamente',
                                            showConfirmButton: true,
                                            allowOutsideClick: false,
                                            timer: 2500,
                                        }).then(async () => {

                                            await this.reloadPage();
                                            //location.reload();
                                            this.disBtn = false;

                                        });

                                    }
                                    else {
                                        this.$swal({
                                            position: 'center',
                                            icon: 'error',
                                            title: 'Error',
                                            text: 'Hubo un error al guardar los datos, Favor de avisar a Desarrollo',
                                            showConfirmButton: true,
                                            allowOutsideClick: false,
                                        })
                                    }
                                }, 2000);

                            });
                        }

                    }
                }
                else {
                    this.validation.errorMovSelect = "Campo Obligatorio";
                }


            },

            async guardarDocs(x) {
                this.disBtn = true;
                var valid = await this.validGral(3);

                if (valid == true) {




                    this.$swal({
                        position: 'center',
                        title: 'Guardando datos...',
                        allowEscapeKey: false,
                        allowOutsideClick: false,
                        didOpen: () => {
                            this.$swal.showLoading();
                        }


                    });

                    var danios = 0;
                    var lesiones = 0;

                    danios = this.danosDatos.montoDanos;

                    lesiones = this.lesionesDatos.montoLesiones;

                    var totalsumadoRec = parseFloat(danios) + parseFloat(lesiones) + parseFloat(this.datosRecuperaciones.sumaMontos);



                    var formData = new FormData();
                    formData.append("nrid", this.datos.nrid);
                    formData.append("mrid", 3);
                    //formData.append("nsobs", $("#txtObsDanios").val());

                    if (this.danoSelected != null) {
                        formData.append("doclave", this.danoSelected.doclave);
                    }


                    formData.append("d3foliodanios", this.danosDatos.folioDanos);
                    formData.append("d3montodocto", this.danosDatos.montoDanos);

                    formData.append("d3foliolesiones", this.lesionesDatos.folioLesiones);
                    formData.append("d3montolesiones", this.lesionesDatos.montoLesiones);
                    formData.append("d3montoPaseMedico", this.lesionesDatos.montoLesionesdocto);
                    formData.append("numPase", this.lesionesDatos.numPases);

                    formData.append("dfnumpago", this.datosRecuperaciones.countPagos);
                    formData.append("montoPago", totalsumadoRec);
                    formData.append("cubreTotal", x);
                    formData.append("totalsumadoRec", totalsumadoRec);

                    formData.append("aseclave", this.asegSelected.aseclave);

                    formData.append("sumaMontos", this.datosRecuperaciones.sumaMontos);
                    formData.append("nrid", this.datos.nrid);
                    formData.append("mrid", this.movSelect.mrid);
                    formData.append("nsfhalta", this.selectedDate);
                    formData.append("nsobs", this.danosDatos.obsDanos);

                    await Recuperaciones.InsertarMovimientoConfPagoDanios(formData).then(response => {



                        setTimeout(() => {
                            this.$swal.close();
                            if (response) {



                                this.$swal({
                                    position: 'center',
                                    icon: 'success',
                                    title: 'Éxito',
                                    text: 'Se guardaron los datos correctamente',
                                    showConfirmButton: true,
                                    allowOutsideClick: false,
                                    timer: 2500,
                                }).then(async () => {

                                    this.reloadPage();
                                    //location.reload();
                                    this.disBtn = false;

                                });

                            }
                            else {
                                this.$swal({
                                    position: 'center',
                                    icon: 'error',
                                    title: 'Error',
                                    text: 'Hubo un error al guardar los datos, Favor de avisar a Desarrollo',
                                    showConfirmButton: true,
                                    allowOutsideClick: false,
                                })
                            }
                        }, 2000);

                    });
                }
                else {
                    this.disBtn = false;
                }





            },

            async validGral(type) {
                if (type == 1) {

                    if (this.observacionesSelected == null) {
                        this.observacionesSelected = "";
                    }

                    var countErrors = 0;

                    if (this.observacionesSelected == null || this.observacionesSelected == '') {
                        this.validation.errorObsMov = "Campo Obligatorio";
                        countErrors++;
                    }
                    else {
                        if (this.observacionesSelected.length < 12) {
                            this.validation.errorObsMov = "Mínimo 12 Carácteres";
                            countErrors++;
                        }
                        else if (this.observacionesSelected.length > 500) {
                            this.validation.errorObsMov = "Máximo 500 Carácteres";
                            countErrors++;
                        }
                    }


                    if (this.movSelect == null) {
                        this.validation.errorMovSelect = "Campo Obligatorio";
                        countErrors++;
                    }

                    if (this.selectedDate == null) {
                        this.validation.errorFecha = "Campo Obligatorio";
                        countErrors++;
                    }


                    if (countErrors > 0) {
                        return false;
                    }
                    else {
                        return true;
                    }

                }
                else if (type == 2) {

                    if (this.observacionesSelected == null) {
                        this.observacionesSelected = "";
                    }

                    var countErrors = 0;

                    if (this.observacionesSelected == null || this.observacionesSelected == '') {
                        this.validation.errorObsMov = "Campo Obligatorio";
                        countErrors++;
                    }
                    else {
                        if (this.observacionesSelected.length < 12) {
                            this.validation.errorObsMov = "Mínimo 12 Carácteres";
                            countErrors++;
                        }
                        else if (this.observacionesSelected.length > 500) {
                            this.validation.errorObsMov = "Máximo 500 Carácteres";
                            countErrors++;
                        }
                    }

                    if (this.movSelect == null) {
                        this.validation.errorMovSelect = "Campo Obligatorio";
                        countErrors++;
                    }

                    if (this.selectedDate == null) {
                        this.validation.errorFecha = "Campo Obligatorio";
                        countErrors++;
                    }

                    //if (this.firma == null || this.firma == '') {
                    //    this.validation.errorFirma = "Campo Obligatorio";
                    //    countErrors++;
                    //}

                    if (countErrors > 0) {
                        return false;
                    }
                    else {
                        return true;
                    }



                }
                else if (type == 3) {


                    var countErrors = 0;

                    if (this.lesionSelected == null && this.danoSelected == null) {

                        this.validaDocs = true;
                        return false;
                    }


                    if (this.danoSelected != null) {



                        if (this.danosDatos.montoDanos == null || this.danosDatos.montoDanos == '') {
                            this.validation.errorMontoDanos = 'Campo Obligatorio';
                            countErrors++;
                        }


                        if (this.danosDatos.obsDanos == null || this.danosDatos.obsDanos == '') {
                            this.validation.errorObsDocs = 'Campo Obligatorio';
                            countErrors++;
                        }
                        else {
                            if (this.danosDatos.obsDanos.length < 12) {
                                this.validation.errorObsDocs = "Mínimo 12 Carácteres";
                                countErrors++;
                            }
                            else if (this.danosDatos.obsDanos.length > 500) {
                                this.validation.errorObsDocs = "Máximo 500 Carácteres";
                                countErrors++;
                            }
                        }



                        if (this.danosDatos.folioDanos == null || this.danosDatos.folioDanos == '') {
                            this.validation.folioDanos = 'Campo Obligatorio';
                            countErrors++;
                        }

                        if (this.asegSelected == null) {
                            this.validation.asegSelected = 'Campo Obligatorio';
                            countErrors++;
                        }


                    }


                    if (this.lesionSelected != null) {



                        if (this.lesionesDatos.numPases == null || this.lesionesDatos.numPases == '') {
                            this.validation.numPases = 'Campo Obligatorio';
                            countErrors++;
                        }

                        if (this.lesionesDatos.montoLesionesdocto == null || this.lesionesDatos.montoLesionesdocto == '') {
                            this.validation.montoLesionesdocto = 'Campo Obligatorio';
                            countErrors++;
                        }


                        if (this.danosDatos.obsDanos == null || this.danosDatos.obsDanos == '') {
                            this.validation.errorObsDocs = 'Campo Obligatorio';
                            countErrors++;
                        }


                        if (this.lesionesDatos.folioLesiones == null || this.lesionesDatos.folioLesiones == '') {
                            this.validation.folioLesiones = 'Campo Obligatorio';
                            countErrors++;
                        }



                    }

                    if (countErrors > 0) {
                        return false;
                    }
                    else {
                        return true;
                    }


                }
                else if (type == 4) {

                    if (this.observacionesSelected == null) {
                        this.observacionesSelected = "";
                    }

                    var countErrors = 0;

                    if (this.datosPago.montoPago == null || this.datosPago.montoPago == '') {
                        this.validation.montoPago = 'Campo Obligatorio';

                        countErrors++;
                    }

                    if (this.formPago.efectivo != true && this.formPago.cheque != true && this.formPago.especia != true) {
                        this.validaPago = true;

                        countErrors++;
                    }

                    if (this.formPago.efectivo == true) {
                        if (this.datosPago.montoEfec == null || this.datosPago.montoEfec == '') {
                            this.validation.montoEfec = 'Campo Obligatorio';
                            countErrors++;
                        }
                    }

                    if (this.formPago.cheque == true) {
                        if (this.datosPago.montoCheque == null || this.datosPago.montoCheque == '') {
                            this.validation.montoCheque = 'Campo Obligatorio';
                            countErrors++;
                        }
                    }


                    if (this.formPago.especia == true) {
                        if (this.datosPago.montoEspecie == null || this.datosPago.montoEspecie == '') {
                            this.validation.montoEspecie = 'Campo Obligatorio';
                            countErrors++;
                        }

                        if (this.datosPago.descEspecie == null || this.datosPago.descEspecie == '') {
                            this.validation.descEspecie = 'Campo Obligatorio';
                            countErrors++;
                        }



                    }




                    if (this.observacionesSelected == null || this.observacionesSelected == '') {
                        this.validation.errorObsMov = "Campo Obligatorio";
                        countErrors++;
                    }
                    else {
                        if (this.observacionesSelected.length < 12) {
                            this.validation.errorObsMov = "Mínimo 12 Carácteres";
                            countErrors++;
                        }
                        else if (this.observacionesSelected.length > 500) {
                            this.validation.errorObsMov = "Máximo 500 Carácteres";
                            countErrors++;
                        }
                    }





                    if (countErrors > 0) {
                        return false;
                    }
                    else {
                        return true;
                    }


                }
                else {
                    return false;
                }



            },
            async PagoModal() {

                this.$swal({
                    position: 'center',
                    title: 'Guardando datos...',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        this.$swal.showLoading();
                    }


                });

                this.modalFecha = false;

                if (this.pagoFecha == 1) {

                    var montopagoModi = parseFloat(this.datosPago.montoPago);
                    var tot = this.movPago.montoneg - montopagoModi;

                    this.totSpan = tot.toString();

                    //this.$swal.close();
                    await this.registrarNuevoPago(this.datos.nrid, this.movPago.numeropago, tot);
                }
                else {
                    var montopagoModi = parseFloat(this.datosPago.montoPago) + parseFloat(this.datosRecuperaciones.sumaMontos);

                    var tot = this.datosRecuperaciones.nrmontoneg - montopagoModi;

                    this.registrarNuevoPagoMayoralSiguiente(this.datos.nrid, this.movPago.numeropago, tot);
                }
            },
            async guardarPago(x) {



                var valid = await this.validGral(4);

                if (valid == true) {


                    this.disBtn = true;



                    var efectivo = this.datosPago.montoEfec != null && this.datosPago.montoEfec != '' ? parseFloat(this.datosPago.montoEfec) : 0;
                    var cheque = this.datosPago.montoCheque != null && this.datosPago.montoCheque != '' ? parseFloat(this.datosPago.montoCheque) : 0;
                    var especie = this.datosPago.montoEspecie != null && this.datosPago.montoEspecie != '' ? parseFloat(this.datosPago.montoEspecie) : 0;

                    var total = efectivo + cheque + especie;

                    var montopagoModi = parseFloat(this.datosPago.montoPago); //Monto a pagar

                    var totalsumado = parseFloat(this.datosPago.montoPago) + parseFloat(this.datosRecuperaciones.sumaMontos);


                    if (totalsumado <= this.datosRecuperaciones.nrmontoneg) {



                        if (total == montopagoModi) {


                            if (this.movPago.numeropago == this.datosRecuperaciones.countPagos && this.movPago.montoneg > montopagoModi) {



                                this.pagoFecha = 1;
                                this.modalFecha = true;

                                this.$swal.close();


                            }
                            else if (this.movPago.numeropago != this.datosRecuperaciones.countPagos && this.movPago.montoneg < montopagoModi) {


                                this.$swal({
                                    position: 'center',
                                    title: 'Guardando datos...',
                                    allowEscapeKey: false,
                                    allowOutsideClick: false,
                                    didOpen: () => {
                                        this.$swal.showLoading();
                                    }


                                });

                                var restante = parseFloat(this.datosPago.montoPago) - parseFloat(this.movPago.montoneg);
                                var formData4 = new FormData();
                                formData4.append("nrid", this.datos.nrid);
                                formData4.append("dfnumpago", this.movPago.numeropago);
                                formData4.append("restante", restante);

                                await Recuperaciones.ObtenerValidacionSigPago(formData4).then(async response => {



                                    if (response[0].validacion == "1") {

                                        await this.guardarConfpago(0);
                                    }
                                    else {

                                        if (parseFloat(totalsumado) == parseFloat(this.movPago.montoneg)) {


                                            await this.guardarConfpago(1);
                                        }

                                        else {

                                            await this.guardarConfpagoMayoralSiguiente(2);
                                        }

                                    }

                                });


                            }
                            else {

                                this.$swal({
                                    position: 'center',
                                    title: 'Guardando datos...',
                                    allowEscapeKey: false,
                                    allowOutsideClick: false,
                                    didOpen: () => {
                                        this.$swal.showLoading();
                                    }


                                });

                                await this.guardarConfpago(0);
                            }

                        }
                        else {


                            //this.$swal.close();

                            this.$swal({
                                position: 'center',
                                icon: 'warning',
                                title: 'Información',
                                text: 'La suma de las cantidades no coinciden con el monto de la recuperación',
                                showConfirmButton: true,
                                allowOutsideClick: false,
                            });

                            this.disBtn = false;
                        }

                    } else {

                        this.$swal.close();

                        if (total != montopagoModi) {



                            this.$swal({
                                position: 'center',
                                icon: 'warning',
                                title: 'Información',
                                text: 'La suma de las cantidades no coinciden con el monto de la recuperación',
                                showConfirmButton: true,
                                allowOutsideClick: false,
                            })


                            this.disBtn = false;
                        }
                        else {
                            this.$swal({
                                position: 'center',
                                icon: 'warning',
                                title: 'El monto a pagar excede del monto de la Recuperación ¿Desea continuar?',
                                allowEscapeKey: false,
                                allowOutsideClick: false,
                                showCancelButton: true,
                                //confirmButtonColor: '#3085d6',
                                //cancelButtonColor: '#d33',
                                confirmButtonText: 'Confirmar',
                                cancelButtonText: 'Cancelar',
                            }).then(async (result) => {
                                if (result.isConfirmed) {
                                    this.$swal({
                                        position: 'center',
                                        title: 'Ingresando Movimiento ...',
                                        allowEscapeKey: false,
                                        allowOutsideClick: false,
                                        didOpen: () => {
                                            this.$swal.showLoading();
                                        }
                                    });



                                    await this.guardarConfpago(1);


                                }
                                else {
                                    this.disBtn = false;
                                }
                            })
                        }



                    }



                }





            },
            async registrarNuevoPago(nrid, numeropago, tot) {

                var formDataFecha = new FormData();
                formDataFecha.append("nrid", nrid);
                formDataFecha.append("dfnumpago", numeropago);
                formDataFecha.append("dfmonto", tot);
                formDataFecha.append("dffhpagoestimado", this.dateFormatted);
                formDataFecha.append("mayor", 0);

                await Recuperaciones.AgregarPagoNuevo(formDataFecha).then(response => {


                    this.guardarConfpago(0);
                });
            },

            async registrarNuevoPagoMayoralSiguiente(nrid, numeropago, tot) {

                var formDataFecha = new FormData();
                formDataFecha.append("nrid", nrid);
                formDataFecha.append("dfnumpago", numeropago);
                formDataFecha.append("dfmonto", tot);
                formDataFecha.append("dffhpagoestimado", this.dateFormatted);
                formDataFecha.append("mayor", 1);

                await Recuperaciones.AgregarPagoNuevo(formDataFecha).then(response => {


                    this.guardarConfpago(0);
                });
            },

            async guardarConfpago(x) {
                var totalsumadoRec = parseFloat(this.datosPago.montoPago) + parseFloat(this.datosRecuperaciones.sumaMontos);

                var formData = new FormData();
                formData.append("dfid", this.movPago.idpago);
                formData.append("nrid", this.datos.nrid);
                formData.append("mrid", 1);
                formData.append("nsfhalta", this.selectedDate);
                formData.append("nsobs", this.observacionesSelected);

                formData.append("nsefectivo", this.formPago.efectivo);
                formData.append("nscheque", this.formPago.cheque);
                formData.append("nsespecie", this.formPago.especia);

                formData.append("nsmontoefectivo", this.datosPago.montoEfec);
                formData.append("nsmontocheque", this.datosPago.montoCheque);
                formData.append("nsmontoespecie", this.datosPago.montoEspecie);

                formData.append("nsdescespecie", this.datosPago.descEspecie);
                formData.append("numeropago", this.movPago.numeropago);
                formData.append("numpagodiferido", this.datosRecuperaciones.countPagos);
                formData.append("dfmonto", this.movPago.montoneg);
                formData.append("montoPago", this.datosPago.montoPago);
                formData.append("cubreTotal", x);
                formData.append("totalsumadoRec", totalsumadoRec);


                await Recuperaciones.InsertarMovimientoConfPago(formData).then(response => {

                    setTimeout(() => {
                        this.$swal.close();
                        if (response) {



                            this.$swal({
                                position: 'center',
                                icon: 'success',
                                title: 'Éxito',
                                text: 'Se guardaron los datos correctamente',
                                showConfirmButton: true,
                                allowOutsideClick: false,
                                timer: 2500,
                            }).then(async () => {

                                this.reloadPage();
                                //location.reload();
                                this.disBtn = false;

                            });

                        }
                        else {
                            this.$swal({
                                position: 'center',
                                icon: 'error',
                                title: 'Error',
                                text: 'Hubo un error al guardar los datos, Favor de avisar a Desarrollo',
                                showConfirmButton: true,
                                allowOutsideClick: false,
                            })
                        }
                    }, 2000);

                });




            },
            async guardarConfpagoMayoralSiguiente(x) {
                var totalsumadoRec = parseFloat(this.datosPago.montoPago) + parseFloat(this.datosRecuperaciones.sumaMontos);

                var formData = new FormData();
                formData.append("dfid", this.movPago.idpago);
                formData.append("nrid", this.datos.nrid);
                formData.append("mrid", 1);
                formData.append("nsfhalta", this.selectedDate);
                formData.append("nsobs", this.observacionesSelected);

                formData.append("nsefectivo", this.formPago.efectivo);
                formData.append("nscheque", this.formPago.cheque);
                formData.append("nsespecie", this.formPago.especia);

                formData.append("nsmontoefectivo", this.datosPago.montoEfec);
                formData.append("nsmontocheque", this.datosPago.montoCheque);
                formData.append("nsmontoespecie", this.datosPago.montoEspecie);

                formData.append("nsdescespecie", this.datosPago.descEspecie);
                formData.append("numeropago", this.movPago.numeropago);
                formData.append("numpagodiferido", this.datosRecuperaciones.countPagos);
                formData.append("dfmonto", this.movPago.montoneg);
                formData.append("montoPago", this.datosPago.montoPago);
                formData.append("cubreTotal", x);
                formData.append("totalsumadoRec", totalsumadoRec);

                await Recuperaciones.InsertarMovimientoConfPagoMayoralSiguiente(formData).then(response => {

                    this.$swal.close();

                    this.pagoFecha = 2;
                    this.modalFecha = true;

                });






            },

            async reloadPage() {

                this.confirmarPago = false;
                this.agregarDocs = false;
                this.danosBlocked = true;
                this.lesionesBlocked = true;
                ////Borado movs
                this.selectedDate = this.maxDate;
                this.firma = '';
                this.observacionesSelected = null;

                this.formPago.efectivo = null;
                this.datosPago.montoEfec = null;

                this.formPago.especia = null;
                this.datosPago.montoCheque = null;

                this.formPago.cheque = null;
                this.datosPago.montoEspecie = null;
                this.datosPago.descEspecie = null;

                this.autorizacion = false;

                //Borrado docs
                this.danoSelected = null;
                this.danosDatos.montoDanos = null;
                this.danosDatos.folioDanos = null;


                this.asegSelected = null;
                this.danosDatos.obsDanos = null;
                this.lesionSelected = null;
                this.lesionesDatos.numPases = null;
                this.lesionesDatos.montoLesionesdocto = null;

                this.lesionesDatos.montoLesiones = null;

                this.lesionesDatos.folioLesiones = null;
                this.disabledmontoLesiones = true;
                ////////////////////////

                this.showcargando = true;
                this.showTable = true;

                await this.reloadTableRunning();

                let datos = await MetodosGenerales.obtenerSessionReporte("reporte");
                this.datos = datos;

                this.displayInputsMovimientos.nrid = this.datos.nrid;
                this.displayInputsMovimientos.nrtippago = this.datos.nrtippago;

                this.displayInputsPago.nrid = this.datos.nrid;
                this.displayInputsPago.nrtippago = this.datos.nrtippago;


                this.validacionEstadistico = await Recuperaciones.ValidarEstadistico(this.datos.nrid);
                var datosTemp = await Recuperaciones.ObtenerDatosDocs(this.datos.nrid);


                this.datosDocs = datosTemp[0];


                var tempRecup = await Recuperaciones.ObtenerDatosRecuperaciones(this.datos.nrid);

                this.datosRecuperaciones = tempRecup[0];

                this.catalogoMov = await Recuperaciones.ObtenerTipoMovimientos();

                for (var i = 0; i < this.catalogoMov.length; i++) {

                    if (this.catalogoMov[i]["mrid"] == 2) {
                        this.movSelect = this.catalogoMov[i];
                    }
                }



                moment.locale("en");

                this.maxDate = moment().format("YYYY[-]MM[-]DD");

                this.selectedDate = this.maxDate;

                this.dateFormatted = this.maxDate;
                let response = await reporteGeneral.fechaSvreporte(this, this.datos);


                this.minDate = response[0]["svfhreporte"];




                if (this.datosDocs.nrfoliodanios != null || this.datosDocs.nrfoliolesiones != null) {

                    this.documentosBlock = true;
                    this.asegBlock = true;
                    this.danosDatos.folioDanos = this.datosDocs.nrfoliodanios;

                    if (this.datosDocs.nrmontodocto == 0) {
                        this.danosDatos.montoDanos = null;
                    } else {
                        this.danosDatos.montoDanos = this.datosDocs.nrmontodocto;
                    }


                    this.lesionesDatos.folioLesiones = this.datosDocs.nrfoliolesiones;
                    this.lesionesDatos.montoLesiones = this.datosDocs.nrmontolesiones;
                    this.lesionesDatos.numPases = this.datosDocs.nrnumpase;

                    setTimeout(() => {
                        this.lesionesDatos.montoLesionesdocto = this.datosDocs.montoLesionesdocto;
                        this.disabledmontoLesiones = true;
                    }, 1000);

                }

                this.showcargando = false;
            }
        },
        watch: {

            movSelect(val) {


                if (val != null) {
                    if (val.mrid == 3) {
                        this.autorizacion = true;
                    }
                    else {
                        this.autorizacion = false;
                    }

                    this.validafirma = false;
                }
                else {

                    this.validafirma = false;
                }



            },
            danoSelected(val) {

                if (this.datosDocs.nrfoliodanios != null || this.datosDocs.nrfoliolesiones != null) {

                }
                else if (val != null) {
                    this.danosBlocked = false;
                    this.validaDocs = false;
                }

                if (this.danoSelected != null && this.danosBlocked == false) {

                    if (this.danoSelected.doclave == 104) {

                        this.danosDatos.montoDanos = 20066;

                    } else {
                        this.danosDatos.montoDanos = null;
                    }
                }

            },

            lesionSelected(val) {
                if (this.datosDocs.nrfoliodanios != null || this.datosDocs.nrfoliolesiones != null) {

                }
                else if (val != null) {
                    this.lesionesBlocked = false;
                    this.validaDocs = false;
                }



            },
            'lesionesDatos.montoLesionesdocto'(val) {
                if (this.datosDocs.nrpasemedico !=0 ) {
                    return
                }
                this.validation.montoLesionesdocto = '';

                if (this.lesionesDatos.numPases != null && this.documentosBlock == false) {

                    this.lesionesDatos.montoLesiones = this.lesionesDatos.numPases * this.lesionesDatos.montoLesionesdocto;//932;
                }

            },
            'lesionesDatos.numPases'(val) {

                if (this.datosDocs.nrpasemedico != 0) {
                    return
                }

                if (val == "") {
                    this.lesionesDatos.montoLesionesdocto = null;
                    this.disabledmontoLesiones = true;
                }
                else {
                    this.lesionesDatos.montoLesionesdocto = 868;
                    this.disabledmontoLesiones = false;
                }
                this.validation.numPases = '';
                if (this.lesionesDatos.numPases != null && this.documentosBlock == false) {
                   
                    this.lesionesDatos.montoLesiones = this.lesionesDatos.numPases * this.lesionesDatos.montoLesionesdocto;//932;
                }

            },
            'lesionesDatos.folioLesiones'(val) {
                this.validation.folioLesiones = '';
            },
            'danosDatos.montoDanos'(val) {
                this.validation.errorMontoDanos = '';
            },
            'danosDatos.folioDanos'(val) {
                this.validation.folioDanos = '';
            },

            'danosDatos.obsDanos'(val) {
                this.validation.errorObsDocs = '';
            },

            'formPago.efectivo'(val) {
                this.validaPago = false;

                if (this.formPago.efectivo == false) {
                    this.datosPago.montoEfec = null;
                }
            },
            'formPago.cheque'(val) {
                this.validaPago = false;

                if (this.formPago.cheque == false) {
                    this.datosPago.montoCheque = null;
                }
            },
            'formPago.especia'(val) {
                this.validaPago = false;

                if (this.formPago.especia == false) {
                    this.datosPago.montoEspecie = null;
                    this.datosPago.descEspecie = null;
                }
            },
            'datosPago.montoEfec'(val) {
                this.validation.montoEfec = '';

            },
            'datosPago.montoCheque'(val) {
                this.validation.montoCheque = '';

            },
            'datosPago.montoEspecie'(val) {
                this.validation.montoEspecie = '';

            },
            'datosPago.descEspecie'(val) {
                this.validation.descEspecie = '';

            },
            'datosPago.montoPago'(val) {
                this.validation.montoPago = '';

            },
            firma(val) {
                this.validafirma = false;
            }


        },
        async mounted() {


            this.showTable = true;

            await this.reloadTable();


            let datos = await MetodosGenerales.obtenerSessionReporte("reporte");
            this.datos = datos;


            await MetodosGenerales.verificarPermisoSolo(
                this.domain.domainNameForApi,
                "VerificarPermiso",
                "311"
            ).then((response) => {
                if (response.data.length > 0) {
                } else {
                    this.$router.push({ name: `NoAutorizado` }).catch((error) => error);
                }
            });


            this.displayInputsMovimientos.nrid = this.datos.nrid;
            this.displayInputsMovimientos.nrtippago = this.datos.nrtippago;

            this.displayInputsPago.nrid = this.datos.nrid;
            this.displayInputsPago.nrtippago = this.datos.nrtippago;


            this.validacionEstadistico = await Recuperaciones.ValidarEstadistico(this.datos.nrid);
            var datosTemp = await Recuperaciones.ObtenerDatosDocs(this.datos.nrid);


            this.datosDocs = datosTemp[0];


            var tempRecup = await Recuperaciones.ObtenerDatosRecuperaciones(this.datos.nrid);

            this.datosRecuperaciones = tempRecup[0];
            const formatoMoneda = new Intl.NumberFormat('es-MX', {
                style: 'currency',
                currency: 'MXN'
            }).format(this.datosRecuperaciones.nrmontoneg);
            this.nrmontoneg = formatoMoneda;

            this.catalogoMov = await Recuperaciones.ObtenerTipoMovimientos();

            for (var i = 0; i < this.catalogoMov.length; i++) {

                if (this.catalogoMov[i]["mrid"] == 2) {
                    this.movSelect = this.catalogoMov[i];
                }
            }



            moment.locale("en");

            this.maxDate = moment().format("YYYY[-]MM[-]DD");

            this.selectedDate = this.maxDate;

            this.dateFormatted = this.maxDate;
            let response = await reporteGeneral.fechaSvreporte(this, this.datos);


            this.minDate = response[0]["svfhreporte"];


            this.showcargando = false;

            if (this.datosDocs.nrfoliodanios != null || this.datosDocs.nrfoliolesiones != null) {

                this.documentosBlock = true;
                this.asegBlock = true;
                this.danosDatos.folioDanos = this.datosDocs.nrfoliodanios;

                if (this.datosDocs.nrmontodocto == 0) {
                    this.danosDatos.montoDanos = null;
                } else {
                    this.danosDatos.montoDanos = this.datosDocs.nrmontodocto;
                }


                this.lesionesDatos.folioLesiones = this.datosDocs.nrfoliolesiones;
                this.lesionesDatos.montoLesiones = this.datosDocs.nrmontolesiones;
                this.lesionesDatos.numPases = this.datosDocs.nrnumpase;

                
                setTimeout(() => {
                    this.lesionesDatos.montoLesionesdocto = this.datosDocs.montoLesionesdocto;
                    this.disabledmontoLesiones = true;
                }, 1000);
            }

        }
    }
</script>

<style scoped>
    .reporteindice {
        color: var(--v-anchor-base);
    }

    .v-picker {
        display: block;
    }

    .dot {
        height: 25px;
        width: 25px;
        border-radius: 50%;
        display: inline-block;
    }
</style>

